<template>
  <div class="dashboard">
    <container align="center">
      <ul>
        <list-item v-for="item in filteredItems" :index="$index" :link="item.link">
          {{item.title}}
        </list-item>
        <list-item @click="logout">
          Log ud
        </list-item>
      </ul>



      <div class="background-layer">
        <div class="animation">
          <sprite :images="images"></sprite>
        </div>
        <p>Oplever du problemer? Kontakt <a class="color-tint" href="mailto:support@mindsocial.dk">support@mindsocial.dk</a></p>
      </div>
    </container>
  </div>
</template>

<script>
import view from '../mixins/view'
import Container from 'components/Container'
import Sprite from 'components/Sprite'
import ListItem from 'components/ListItem'
import { invalidateToken } from '../vuex/auth/actions'
import { role } from 'state/auth/getters'
import { map } from '../router.js'

export default {
  name: 'Dashboard',
  mixins: [view],
  vuex: {
    actions: {
      invalidateToken
    },
    getters: {
      role
    }
  },
  data () {
    return {
      items: [
        {
          title: 'Øvelser',
          link: {
            name: 'exercises'
          }
        },
        {
          title: 'Hold',
          link: {
            name: 'teams'
          }
        }
      ],
      images: [
        require('src/assets/sprites/virker-det.png')
      ]
    }
  },
  computed: {
    filteredItems() {
      // only routes not forbidden for current user
      var forbidden = []
      for (let key in map) {
        if (typeof map[key].meta === 'undefined' || typeof map[key].meta.forbiddenRoles === 'undefined') continue

        if (map[key].meta.forbiddenRoles.includes(this.role) || this.role === null) {
          forbidden.push(map[key].name)
        }
      }
      return this.items.filter(item => !forbidden.includes(item.link.name))
    }
  },
  components: {
    Container,
    ListItem,
    Sprite
  },
  methods: {
    logout () {
      this.invalidateToken()
      .then(response => {
        if (response.status === 200) {
          // do a force redirect to clean Vuex state, cached getters etc.
          // this.$router.go({name: 'login'})
          window.location.href = '/login'
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/boilerplate';

.dashboard {
  flex: 1;
  min-height: 100%;
  display: flex;
  align-items: center;
}
ul {
  flex: 1;
}
.background-layer {
  position: fixed;
  width: 50%;
  right: 0;
  top: 0;
  height: 100%;
  background-color: $color-lightgrey;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10vw;

  p {
    position: absolute;
    bottom: 4rem;
    width: 100%;
    left: 0%;
    text-align: center;
    padding: 0 1rem;
  }
}
.animation {
  width: 100%;
  position: relative;
  @include use-ratio(square);

  .sprite {
    top: 0;
  }
}
</style>



// WEBPACK FOOTER //
// Dashboard.vue?69e3f0e0